import axios from 'axios';
import { apiClient, getAuthorizationHeaders } from '@/services/authenticatedApiClient';

class AppUploadService {
  public upload(url: string, files: File[]): Promise<void> {
    return getAuthorizationHeaders().then(headers => {
      if (files.length) {
        const formData = new FormData();
        files.forEach((f, index) => {
          formData.append(`file${index}`, f, f.name);
        });
        const config = {
          headers
        };
        const action = `${apiClient.defaults.baseURL}${url}`;
        return axios
          .put(action, formData, config)
          .then(() => {
            return;
          })
          .catch(res => {
            throw (res.response.data.File && res.response.data.File.length && res.response.data.File[0]) || res;
          });
      }
    });
  }
}

export const appUploadService = new AppUploadService();
